import { Platform } from 'react-native';
import { PressableIcon } from '@bonanza-social/moonlight';
import { Modal, ParamListBase } from '@bonanza-social/navigation';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

type CloseButtonProps<T extends ParamListBase> = {
  navigation: NativeStackNavigationProp<T>;
};

function CloseButton<T extends ParamListBase>({
  navigation,
}: CloseButtonProps<T>) {
  return (
    <PressableIcon
      name="close"
      width="space-800"
      height="space-800"
      padding="space-100"
      gradient="accentBackground"
      onPress={
        Platform.OS === 'web'
          ? Modal.close
          : (navigation.getParent()?.goBack ?? navigation.goBack)
      }
      testID="close-button"
    />
  );
}

export default CloseButton;
